// extracted by mini-css-extract-plugin
var _1 = "Core_collapsed__b6B14";
var _2 = "Core_message__H+b3+";
var _3 = "Core_messageCloseButton__q5kMR";
var _4 = "Core_messageCloseIcon__o4u7I";
var _5 = "Core_messageCollapsed__w56Nv";
var _6 = "Core_messageContent__tLqvR";
var _7 = "Core_messageHeader__Rrg1b";
var _8 = "Core_messageIcon__avIjh";
var _9 = "Core_messageIconCollapsed__NJc-q";
var _a = "Core_messageTitle__m7xQh";
export { _1 as "collapsed", _2 as "message", _3 as "messageCloseButton", _4 as "messageCloseIcon", _5 as "messageCollapsed", _6 as "messageContent", _7 as "messageHeader", _8 as "messageIcon", _9 as "messageIconCollapsed", _a as "messageTitle" }
